module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-form', {
    ref: "ruleForm2",
    staticClass: "demo-ruleForm login-container grijs",
    staticStyle: {
      "width": "280px"
    },
    attrs: {
      "model": _vm.ruleForm2,
      "rules": _vm.rules2,
      "visible": _vm.loginVisible,
      "label-position": "left",
      "label-width": "0px"
    },
    on: {
      "update:visible": function($event) {
        _vm.loginVisible = $event
      }
    }
  }, [_c('h3', {
    staticStyle: {
      "margin-bottom": "45px",
      "margin-top": "0",
      "color": "#409EFF"
    }
  }, [_c('span', [_c('img', {
    staticStyle: {
      "float": "left",
      "height": "55px",
      "xwidth": "50px",
      "margin-top": "-5px",
      "border-radius": "4px"
    },
    attrs: {
      "src": require("../../static/img/tui-main.png")
    }
  })]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("WRD Service App")]), _c('br'), _vm._v(" "), (_vm.loginMode < 2) ? _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("Login "), _c('span', {
    staticClass: "special"
  }, [_vm._v(_vm._s(this.stage))])]) : _c('span', {
    class: _vm.stageClass,
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("Tui WRD")])]), _vm._v(" "), (_vm.loginMode != 2) ? _c('span', [_c('el-form-item', {
    attrs: {
      "prop": "account"
    }
  }, [_c('el-input', {
    ref: "account",
    attrs: {
      "type": "text",
      "autofocus": "",
      "auto-complete": "off",
      "placeholder": "Your Logincode"
    },
    model: {
      value: (_vm.ruleForm2.account),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "account", $$v)
      },
      expression: "ruleForm2.account"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "checkPass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "and password",
      "show-password": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleSubmit2.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.ruleForm2.checkPass),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "checkPass", $$v)
      },
      expression: "ruleForm2.checkPass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%",
      "margin-top": "20px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.logining
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit2.apply(null, arguments)
      }
    }
  }, [_vm._v("Login")])], 1), _vm._v(" "), (_vm.loginMode != 2) ? _c('el-form-item', [_c('el-button', {
    staticStyle: {
      "margin-top": "-10px",
      "float": "right"
    },
    attrs: {
      "type": "text",
      "loading": _vm.logining,
      "show-password": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.resetPassword.apply(null, arguments)
      }
    }
  }, [_vm._v("Reset Password")])], 1) : _vm._e()], 1) : _c('span', [_c('center', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.logining
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit2.apply(null, arguments)
      }
    }
  }, [_vm._v("Start Application")])], 1)], 1), _vm._v(" "), _c('font', {
    staticStyle: {
      "font-size": "9px",
      "font-family": "verdana"
    }
  }, [_c('center', [_vm._v("©2022 Tui-WRD. Created by Ruud Noordermeer ")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Reset your Password",
      "visible": _vm.resetVisible,
      "width": "300px"
    },
    on: {
      "update:visible": function($event) {
        _vm.resetVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "resetForm",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "model": _vm.resetForm,
      "label-width": "60px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Email :",
      "prop": "deptemail"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.resetForm['email']),
      callback: function($$v) {
        _vm.$set(_vm.resetForm, 'email', $$v)
      },
      expression: "resetForm['email']"
    }
  })], 1), _vm._v(" "), _c('el-col', [_c('div', {
    staticStyle: {
      "font-size": "13px",
      "margin-left": "60px",
      "margin-bottom": "20px"
    }
  }, [_vm._v("\n         NOTE: THIS FUNCTION IS NOT YET AVAILABLE!!"), _c('br'), _c('br'), _vm._v("\n         After pressing the 'Reset' button we will send you an email"), _c('br'), _vm._v("with further instructions.\n\t     ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "icon": "el-icon-upload2"
    },
    nativeOn: {
      "click": function($event) {
        _vm.resetVisible = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.isEmailInvalid(_vm.resetForm['email']),
      "size": "small",
      "type": "primary",
      "icon": "el-icon-edit"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.resetSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("Reset")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ba26bd4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Login.vue
// module id = 647
// module chunks = 1